module.exports = __webpack_public_path__ + "static/media/leaderboard-img6.9d733aba.jpeg";